<template lang="pug">
    .container(
        ref='container',
        )
        .animated-scroll(
            ref='animatedScroll',
            )
                .map-wrap(ref='map')
                    img(src='../../assets/img/article-header/map.svg')
                    .city(ref='city' v-for='(city, cityIndex) in settings.cities', :key='`${city.name}-${cityIndex}`', :style='city.coordinates', :class='city.modifier')
                        .city__dot(ref='dot' :class='city.modifier')
                        span.city__name(ref='name' v-html='city.name' :class='city.modifier')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

export default {
    props: {
        settings: Object,
        isActive: Boolean
    },
    data() {
        return {
            bScrollInst: null,
            timeline: null,
            isInited: false,
            innerBlockPosition: 'top'
        };
    },
    mixins: [mixinAnimation],
    methods: {
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});
            this.timeline
                .set(this.$refs.dot, {scale: 0})
                .set(this.$refs.name, {opacity: 0})
                .fromTo(this.$refs.dot, {scale: 0}, {scale: 1, duration: 1, stagger: {each: 4}}, 0)
                .fromTo(this.$refs.name, {opacity: 0}, {opacity: 1, duration: 1, stagger: {each: 4}}, 1);
            //.fromTo(this.$refs.name, {opacity: 1}, {opacity: 0, duration: 1, stagger: {each: 4}}, 3);
            //.fromTo(this.$refs.dot, {scale: 1}, {scale: 0, duration: 1, stagger: {each: 4}}, 3)

            this.timeline.progress(0.0001);
            this.timeline.pause();
        },
        createAnimation() {
            this.createTimeline();
            this.createScroll();
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';

.container {
    height: 300vh;
    position: relative;
    overflow: hidden;
    @media screen and (--viewport-tablet) {
        width: 300vw;
    }
}

.animated-scroll {
    background-color: #000;
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    min-height: 100vh;
    width: 100%;
    display: flex;
    @media screen and (--viewport-tablet) {
        width: 100vw;
    }
    &.fixed {
        position: fixed;
        top: 0;
        left: 0;
    }

    &.bottom {
        bottom: 0;
        top: auto;
    }
}

.map-wrap {
    width: calc(var(--grid-column) * 20);
    margin: auto;
    position: relative;

    @media (--viewport-laptop) {
        width: calc(var(--grid-column-laptop) * 21);
    }

    @media screen and (--viewport-tablet) {
        //width: calc(var(--grid-column-mobile) * 11);
        min-width: 200vw;
        position: relative;
        left: -116%;
        max-height: calc(90 * var(--vh));
    }
    img {
        @media screen and (--viewport-tablet) {
            //height: fit-content;
        }
    }
}

.city {
    position: absolute;
    display: flex;
    align-items: center;
    width: fit-content;

    &__dot {
        transform-origin: center;
        height: 1rem;
        width: 1rem;
        border-radius: 50%;
        background-color: var(--theme);
        margin-right: 10px;
        //transform: scale(0);
        will-change: transform;

        @media (--viewport-mobile-l) {
            height: 0.5rem;
            width: 0.5rem;
        }

        &.reverse {
            margin-left: 10px;
            margin-right: 0;
        }
        &.mob-straight {
            @media (--viewport-tablet) {
                order: 1 !important;
            }
        }
    }

    &__name {
        font-family: var(--font-main);
        font-weight: bold;
        font-size: 0.75rem;
        line-height: 0.75rem;
        text-transform: uppercase;
        color: var(--theme);

        &.reverse {
            order: -1;
        }
        &.mob-straight {
            @media (--viewport-tablet) {
                order: 1 !important;
            }
        }
    }
}
</style>
